<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 21" role="img" aria-labelledby="DifficultyLevelIconTitle">
    <title id="DifficultyLevelIconTitle">Difficulty Level</title>
    <path
      d="M23.905.28h-5.18c-.42 0-.77.35-.77.77v18.9c0 .42.35.77.77.77h5.215c.42 0 .77-.35.77-.77V1.05c-.035-.42-.385-.77-.805-.77zm-.77 18.9H19.46V1.82h3.675v17.36zm-8.05-14.315H9.87c-.42 0-.77.35-.77.77V19.95c0 .42.35.77.77.77h5.215c.42 0 .77-.35.77-.77V5.635c-.035-.42-.35-.77-.77-.77zm-.77 14.315H10.64V6.405h3.675V19.18zM6.23 9.45H1.015c-.42 0-.77.35-.77.77v9.73c0 .42.35.77.77.77H6.23c.42 0 .77-.35.77-.77v-9.73c0-.42-.35-.77-.77-.77zm-.77 9.73H1.785v-8.19H5.46v8.19z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
